// extracted by mini-css-extract-plugin
export var carrierNotice = "_hu-5";
export var carrierNoticePlaceholder = "_hu-6";
export var deliveryRow = "_hu-c";
export var fixedHeight = "_hu-4";
export var freightLogo = "_hu-b";
export var fullWidth = "_hu-3";
export var priceColumn = "_hu-7";
export var radioSelected = "_hu-9";
export var radioUnselected = "_hu-8";
export var selectedOption = "_hu-2";
export var selectedOptionContainer = "_hu-1";
export var selection = "_hu-0";
export var tallSkeletonText = "_hu-a";